<section class="bg-white shadow-lg">
    <div
        class="container pt-28 pb-16 lg:pt-48 lg:pb-60 grid-cols-12 px-3 md:px-auto items-center">
        <div class=" px-3 md:px-auto lg:pt-20 md:text-center">
            <h1 class="text-color md:text-center text-3xl md:text-6xl sm:leading-[45px]  font-bold gradient-text ">
                <span class="">
                                    Smart, Efficient, Powerful – Volmint’s
                </span>
                <br>
                <strong>
                    Campus Management
                    System
                </strong>

            </h1>
            <p class="py-5 text-center hidden md:block  md:text-[18px] md:w-[80%] mx-auto">Volmint Technologies brings you an all-in-one Campus Management System that
                simplifies every aspect of college and university administration. With our innovative CMS and UMS, we
                simplify everything - from student enrollment and fee management to class schedules, exam management,
                and beyond.
            </p>
            <p class="md:hidden text-[14px] my-4">Volmint Technologies brings you an all-in-one Campus Management System that simplifies and automates college and university operations.
            </p>
        </div>
        <div class="px-3 md:hidden">
            <button
                class=" my-5  bg-background transition-all duration-300 hover:bg-white hover:text-blue-700 px-14 py-3 font-bold text-white text-[16px]"
                (click)="openModal()">Book a Free Demo <i class="fa fa-arrow-right ms-1"></i>
            </button>
        </div>
        <div class="mx-auto hidden md:block items-center justify-center flex flex-wrap lg:w-8/12 md:mb-44 ">
            <div class="w-full flex lg:flex-nowrap flex-wrap justify-center md:mb-20 bg-gray-200 px-5 pt-2 pb-0 rounded-lg hover:border duration-300 hover:border-[#0a2e88]">
                <app-form [showLimitedFields]="true"></app-form>
                <button
                    class="h-[50px] md:mt-1 lg:ms-3   bg-background transition-all duration-300 hover:bg-white hover:text-blue-700 px-10 text-nowrap py-0 font-bold text-white text-[16px]"
                    (click)="submit()">Submit <i class="fa fa-arrow-right ms-1"></i>
                </button>
            </div>

        </div>
    </div>
</section>
<div
    class=" items-center  gradient-bg lg:flex shadow-xl mx-4 mt-12 md:py-24 lg:py-28 xl:pb-40 rounded-lg lg:pe-0 ">
    <div class="md:container relative ">
        <div class=" mx-auto w-full bg-transparent px-0 rounded-xl md:absolute md:top-[-400px] text-center lg:top-[-450px]  xl:top-[-550px]">
            <img src="assets/image/CMS Landing Page Hero Image-01-01-01.webp" alt=""
                 class=" mx-auto h-full  z-10">

        </div>
    </div>
</div>
<div class="container px-4 pt-14 md:py-14">
    <p class="text-gray-900 text-center text-lg md:mt-5 hidden md:block">Our happy clients trust us. We are proud to collaborate with industry leaders
        and businesses of all sizes, delivering exceptional results. Here are some of the brands that have placed their
        trust in us.</p>
    <h2 class="md:hidden block text-color text-2xl font-bold text-center">Our Esteemed Clients</h2>
    <div class="flex flex-wrap gap-1 md:px-3 justify-between py-10">
        <div
            class="h-[70px] md:h-[100px] py-4 mx-auto w-[48%] rounded clients md:w-[18%] flex items-center px-4 md:py-2">
            <img src="assets/image/img_5.png" alt="" class="mx-auto color-img">
            <img src="assets/image/6ac9c21f-4966-40ef-92be-e44d64dd21f3.png" alt="" class="mx-auto black-img">
        </div>
        <div
            class="h-[70px] md:h-[100px] py-4 mx-auto w-[48%]   rounded clients md:w-[18%] flex items-center px-4 md:py-2">
            <img src="assets/image/img_6.png" alt="" class="mx-auto color-img">
            <img src="assets/image/f5348841-c262-4d9c-b86c-32e9c3ef0f47.png" alt="" class="mx-auto black-img">
        </div>
        <div
            class="h-[70px] md:h-[100px] py-4 mx-auto w-[48%]   rounded clients md:w-[18%] flex items-center px-4 md:py-2">
            <img src="assets/image/img_7.png" alt="" class="mx-auto color-img">
            <img src="assets/image/img_7 (1).png" alt="" class="mx-auto black-img">
        </div>
        <div
            class="h-[70px] md:h-[100px] py-4 mx-auto w-[48%]   rounded clients md:w-[18%] flex items-center px-4 md:py-2">
            <img src="assets/image/img_8.png" alt="" class="mx-auto color-img">
            <img src="assets/image/img_8s.png" alt="" class="mx-auto black-img">

        </div>
<!--        <div-->
<!--            class="h-[70px] md:h-[100px] py-4 mx-auto w-[48%]   rounded clients md:w-[18%] flex items-center px-4 md:py-2">-->
<!--            <img src="assets/image/img_9.png" alt="" class="mx-auto color-img">-->
<!--            <img src="assets/image/img_9 (1).png" alt="" class="mx-auto black-img">-->
<!--        </div>-->
        <div
            class="h-[70px] md:h-[100px] py-4 mx-auto w-[48%]   rounded clients md:w-[18%] flex items-center px-4 md:py-2">
            <img src="assets/image/img5.png" alt="" class="mx-auto color-img">
            <img src="assets/image/image (8).png" alt="" class="mx-auto black-img">
        </div>
    </div>
</div>

<div
    class="container mx-auto rounded-lg  bg-white lg:pe-0 ">
    <div class="w-full md:px-5 md:py-10">
        <div class="flex  flex-wrap justify-between">
            <div class="md:w-3/6">
                <h2 class=" text-2xl text-center md:text-start md:text-4xl text-color font-bold mb-5">Effortless Campus
                    Management at Your Fingertips
                </h2>
            </div>
            <div class="text-center md:text-end hidden md:block w-full md:w-3/6">
                <button
                    class=" lg:ms-3  md:w-auto bg-background transition-all duration-300 hover:bg-white hover:text-blue-700 px-14 py-3 font-bold text-white text-[16px]"
                    (click)="openModal()">Book a Free Demo <i class="fa fa-arrow-right ms-1"></i>
                </button>
            </div>
        </div>
        <p class="mt-4 md:my-0 text-justify md:w-3/6">The campus management system seamlessly integrates all essential
            processes. Designed for modern campuses, improves efficiency and focuses on delivering quality education
            while ensuring smooth operations. Empower institutions to deliver a world-class education.
        </p>
    </div>
    <div class="w-full  pt-5 md:pt-0">
        <div class="flex  justify-center  md:py-5">
            <video *ngIf="isPlaying" class="w-full shadow-lg rounded-xl" controls autoplay>
                <source src="assets/image/cms_new.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <div class="relative">
                <img *ngIf="!isPlaying" src="assets/image/CMS%20thumbnail.png"
                     class=" rounded-lg cursor-pointer" alt="College Management System Image" (click)="playVideo()">
                <button *ngIf="!isPlaying"
                        class="absolute inset-0 flex items-center justify-center bg-black/50 rounded-lg"
                        (click)="playVideo()">
                    <span class="w-20 h-20  border-2 border-sky-400 rounded-full flex items-center justify-center">

                    <svg class="w-12 h-12 text-sky-400" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z"></path>
                    </svg>
                    </span>
                </button>
            </div>
        </div>
        <div class="text-center md:hidden">
            <button
                class=" my-5  bg-background transition-all duration-300 hover:bg-white hover:text-blue-700 px-14 py-3 font-bold text-white text-[16px]"
                (click)="openModal()">Book a Free Demo <i class="fa fa-arrow-right ms-1"></i>
            </button>
        </div>

    </div>
</div>
<section class="mt-10 md:mt-20">
    <div class="container pb-10">
        <div class=" ">
            <h2 class=" text-center font-bold text-2xl md:text-5xl text-color ">Key Features</h2>
        </div>
        <div class=" px-0 mx-auto pt-10 md:pb-20 gap-4 flex  flex-wrap ">
            <div
                class="  flex-col  items-center rounded-lg shadow-lg  bg-white featureBox  w-full md:w-[48%] lg:w-[32%] "
                *ngFor="let item of features">

                <div class=" w-full py-2 border-b  items-center px-5 pt-5 pb-2 ">
                    <p>
                        <i [ngClass]="[item.icon, item.iconColor]"   class=" text-4xl   "></i>
                    </p>

                   <!-- <div
                        class="iconbox px-4 rounded ">
                        <i [ngClass]="item.icon" class="brand-text text-xl py-3  "></i>
                    </div>-->
                    <p class="brand-text text-xl mt-2 font-bold">{{ item.title }}</p>
                </div>

                <ul class=" w-full  my-0 px-5 py-5 ">
                    <li *ngFor="let point of item.pointers" class="mb-2  ">
                     <i class="fa fa-check text-cyan-700 text-[16px] me-1"></i>  {{point}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>
<section class=" h-full pb-10 md:pb-28">
    <div class="container md:px-0 grid md:grid-cols-2 text-color   relative z-10">
        <div class="col-span-12">
            <div class="">
                <div class=" mx-auto">
                    <h2 class="text-2xl md:text-5xl pb-3 font-bold text-center text-color">Modules We Provide
                    </h2>
                    <p class="text-color text-center pt-3">An education ERP system called a UMS facilitates information
                        sharing between educators,
                        learners, parents, outside vendors, and learning providers, among others, by providing a
                        platform for
                        communication.
                    </p>
                    <div class="h-58 py-6">
                        <app-tabs></app-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<div class="">
    <div class="container mx-auto">
        <div class="md:px-28">
            <h2 class="text-2xl md:text-5xl pb-3  font-bold text-center text-color">What Makes Our Campus Management System
                Stand Out?
            </h2>
        </div>

        <p class="text-color text-justify mt-5 my-3">Volmint College Management System (CMS) is a comprehensive, cloud-based
            solution
            created to transform the administration of colleges by simplifying processes, promoting effective
            communication, and giving students greater self-sufficiency. Volmint provides various benefits and
            customized features in CMS to deliver the best to our clients.</p>
        <div class="grid sm:grid-cols-2 md:grid-cols-12 gap-5 mt-4">
            <div
                class="sm:col-span-12 md:col-span-6 lg:col-span-4  shadow text-black"
                *ngFor="let item of learning">
                <div class="p-6">
                    <i [ngClass]="item.icon" class="brand-text text-4xl"></i>
                    <h3 class="text-[20px] font-bold brand-text mt-2  ">{{ item?.title }}</h3>
                    <p class="my-2 text-[14px] text-color leading-6">{{ item.content }}</p>
                </div>
            </div>
        </div>
    </div>
</div>
<section class=" h-full pt-10 md:pt-24">
    <div class=" grid md:grid-cols-12 w-[90%] md:w-[90%] xl:w-[70%] mx-auto top-[100px] items-center">
        <div class=" md:p-[30px] col-span-12 mb-20  lg:mb-0 lg:col-span-12 bg-transparent">
            <h2 class="text-2xl md:text-5xl mb-10 text-center font-bold text-color">Our Complimentary Offerings at No Extra Cost</h2>
            <div class="flex flex-wrap ">
                <div class="w-full  md:w-1/2 xl:w-1/3 px-2 " *ngFor="let item of offerings">
                    <div class="border transition-all duration-300  flex items-center mb-2  justify-start rounded-lg p-4 md:py-8 hover:shadow-lg hover:bg-white hover:border-0">
                          <span
                              class="w-16 h-16 flex justify-center items-center bg-white shadow-lg rounded p-3 ">
<!--                              <icon [src]="item.icon" alt="">-->
                              <i [ngClass]="[item.icon, item.color ]" class="text-2xl"></i>
                          </span>
                        <span class="ml-4 md:text-[16px] lg:text-lg font-semibold brand-text transition-colors duration-300 hover:text-indigo-500">
                                {{ item.text }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="p-2 md:py-20">
    <app-carousel></app-carousel>
</section>
